module.exports = "https://milano-network.servercdn.it/static/img/FuturaPT-Demi.svg?1cb27fd2c51337e989538dc7ae6a26cf";